
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { baseUrl_SPB } from '../BaseUrl';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const CustomerSearch = () => {
  const authContext = useAuth();
  const [customers, setCustomers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCustomers = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${baseUrl_SPB}/api/v1/businesscustomers/getcustomers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token,
        },
      });
      if (!response.ok) throw new Error('Failed to fetch customers');
      let data = await response.json();
      data = data.map(item => ({ ...item, key: item.id || uuidv4() }));
      setCustomers(data);
      setFiltered(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if(authContext?.token)
        fetchCustomers();
    // eslint-disable-next-line
  }, [authContext.token]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (!value) {
      setFiltered(customers);
      return;
    }
    const lower = value.toLowerCase();
    setFiltered(
      customers.filter(item =>
        (item.firstName && item.firstName.toLowerCase().includes(lower)) ||
        (item.lastName && item.lastName.toLowerCase().includes(lower)) ||
        (item.email && item.email.toLowerCase().includes(lower)) ||
        (item.phoneNumber && item.phoneNumber.toLowerCase().includes(lower)) ||
        (item.businessName && item.businessName.toLowerCase().includes(lower)) ||
        (item.abn && item.abn.toLowerCase().includes(lower))
      )
    );
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>Customer Search</Typography>
      <TextField
        label="Search by name, email, phone, business, ABN..."
        value={search}
        onChange={handleSearch}
        fullWidth
        sx={{ mb: 2 }}
      />
      {loading ? <CircularProgress /> : error ? <Typography color="error">{error}</Typography> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Business Name</TableCell>
                <TableCell>ABN</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.length === 0 ? (
                <TableRow><TableCell colSpan={6} align="center">No customers found</TableCell></TableRow>
              ) : filtered.map(item => (
                <TableRow key={item.key}>
                  <TableCell>{item.firstName}</TableCell>
                  <TableCell>{item.lastName}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{item.phoneNumber}</TableCell>
                  <TableCell>{item.businessName}</TableCell>
                  <TableCell>{item.abn}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default CustomerSearch;
